import React, { useState } from "react";
import Service from '../../../service/Service';

const service = new Service();

export default function FeedbackPopup({eleRef}) {
    
    const [activeIndex, setActiveIndex] = useState(null);


    const handleFeedbackChange = (e) => {

        const value = e.target.value;

        // limit 250 chars
        if (value.length <= 250) {
            eleRef.setState({
                feedbacktext: value,
                feedbackError: ""
            });
        }
    };

    const sendFeedback = () => {

        const feedback = eleRef.state.feedbacktext?.trim();

        if (!feedback) {

            eleRef.setState({
                feedbackError: "Please enter feedback"
            });

            setTimeout(() => {
                eleRef.setState({
                    feedbackError: ""
                });
            }, 1000);

            return;
        }


        let postdata={
            "feedbacktext": eleRef.state.feedbacktext
        }

        let url = global.api_ci_url + "api/fetchfromCI/sendfeedback"; 


        service.postServiceCall(url, postdata)
        .then((json) => { 
            console.log('------------------json', json);
            if(json.msg == 1){

                eleRef.closeFeedback()
                eleRef.setState({
                    feedbacktext: "",
                    feedbackError: ""
                });
            }
           
        })
        .catch((err) => {
            console.log(err);
        });
        
        console.log("Feedback Submitted:", feedback);
        
    };

   
    return (
        <div className="showFeedback-overlay">
           <div className="showFeedbackmodal">
                <div className="chart_closeBtn" onClick={eleRef.closeFeedback}>
                    <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/closeBtn.png" alt="close"></img>
                </div>
                <div className="feedback_body">
                    <div className="feedback_text">
                        <textarea
                            id="feedbacktext"
                            name="feedbacktext"
                            value={eleRef.state.feedbacktext}
                            onChange={handleFeedbackChange}
                            maxLength={250}
                            placeholder="Your feedback is valuable to us which will help us serve you better. Share your feedback about our vaccination Tracker here in 250 characters."
                        />
                    </div>
                    {eleRef.state.feedbackError &&
                        <div className="feedback_error">
                            {eleRef.state.feedbackError}
                        </div>
                    }
                    
                </div>
                <div className="feedback_footer">
                    <div className="feedbackSubmit">
                        <span className="B14_white" onClick={sendFeedback} >Submit</span>
                        <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/ic-send.png" alt="send"></img>
                    </div>
                </div>
                    

            </div>
        </div>
    );
};

